<template>
    <BContainer style="max-width: 700px;">
        <BCard>
            <BCardHeader class="p-4">
                <h1 class="h4">
                {{ $t('pages.acceptCert.pageTitle') }}
                </h1>
            </BCardHeader>
            <BCardBody>
                <BForm>
                    <div>
                        <p>
                            {{ $t('pages.acceptCert.certStatement') }}
                        </p>
                        <p>
                            {{ $t('pages.acceptCert.certStatement2') }}
                        </p>
                        <p>
                            {{ $t('pages.acceptCert.certStatement3') }}
                        </p>
                        <p>
                            {{ $t('pages.acceptCert.certStatement4') }}
                        </p>
                        <p>
                            {{ $t('pages.acceptCert.certStatement5') }}
                        </p>
                    </div>
                    <br>
                    <BFormGroup
                    :key="'termsAgreed'">
                        <FrField
                            v-model="termsAgreed"
                            :label="'Accept Certificate'"
                            :type="'checkbox'" 
                            :validation="'required'"/>
                    </BFormGroup>
                </BForm>
                <BRow class="justify-content-end">
                    <BCol md="4">
                        <BButton
                            @click="save"
                            variant="primary"
                            :disabled="!termsAgreed"
                            class="align-self-end">
                            {{ $t('pages.acceptCert.save') }}
                        </BButton>
                    </BCol>
                </BRow>
            </BCardBody>
        </BCard>
    </BContainer>
</template>
<script>
import {
    BCard,
    BCardBody,
    BCardHeader,
    BCol,
    BRow,
    BButton,
    BFormGroup,
    BForm,
    BContainer
  } from 'bootstrap-vue';
import NotificationMixin from '@forgerock/platform-shared/src/mixins/NotificationMixin';
import RestMixin from '@forgerock/platform-shared/src/mixins/RestMixin';
import { mapState } from 'vuex';
import FrField from '@forgerock/platform-shared/src/components/Field';
export default {
    name: 'acceptCert',
    components: {
        BCard,
        BCardBody,
        BCardHeader,
        BCol,
        BRow,
        BButton,
        BFormGroup,
        BForm,
        FrField,
        BContainer,
    },
    mixins: [
        NotificationMixin,
        RestMixin,
    ],
    directives: {
    },
    props: {
    },
    computed: {
        ...mapState({
            userUid: (state) => state.UserStore.userId,
        })
    },
    data() {
        var data = {
            termsAgreed: false
        };
        return data;
    },
    mounted() {
    },
    methods: {
        save () {
            var wfdata, loginServiceInstance, result;
            loginServiceInstance = this.getRequestService();
            loginServiceInstance.get('managed/user/' + this.userUid)
                .then((loggedInUserResponse) => {
                    result = loggedInUserResponse.data;
                    if (result.promotingAdmin !== undefined && result.promotingAdmin.length > 0) {
                        let termsAgreedVal = (this.termsAgreed) ? 'Yes' : 'No';
                        wfdata = JSON.stringify([{
                            'operation': 'replace',
                            'field': '/termsAgreed',
                            'value': `${termsAgreedVal}`
                        },
                        {
                            'operation': 'replace',
                            'field': '/signedCertification',
                            'value': 'Yes'
                        }
                        ]);
                        loginServiceInstance.patch('managed/user/' + this.userUid, wfdata).then((updatedUserResponse) => {
                            this.displayNotification('success', this.$t('pages.acceptCert.successMessage'));
                            this.$router.push({
                                name: 'Dashboard'
                            });
                        }).catch((error) => {
                            error = undefined;
                            this.displayNotification('error', this.$t('pages.acceptCert.failureMessage'));
                        });
                    } else {
                        this.displayNotification('error', this.$t('pages.acceptCert.noPromotionRequest'));
                    }
                })
                .catch(function (error) {
                    error = undefined;
                });
        }
    }
};
</script>